import React from "react";
import { Button } from "@mui/material";

const DefaultDeleteIcon = ({ color }) => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.4688 6.02368C18.1388 5.69368 14.7887 5.52368 11.4487 5.52368C9.46875 5.52368 7.48875 5.62368 5.50875 5.82368L3.46875 6.02368" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.96875 5.0137L9.18875 3.7037C9.34875 2.7537 9.46875 2.0437 11.1587 2.0437H13.7788C15.4688 2.0437 15.5987 2.7937 15.7487 3.7137L15.9688 5.0137" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.3191 9.18372L18.6691 19.2537C18.5591 20.8237 18.4691 22.0437 15.6791 22.0437H9.25914C6.46914 22.0437 6.37914 20.8237 6.26914 19.2537L5.61914 9.18372" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.7988 16.5437H14.1288" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.96875 12.5437H14.9688" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const DeleteButton = ({
    label,
    color = "white",
    iconColor = "#960101",
    variant = "contained",
    startIcon,
    onClick,
    sx = {},
    ...props
}) => {

    return (
        <Button
            color={color}
            variant={variant}
            onClick={onClick}
            startIcon={startIcon || <DefaultDeleteIcon color={iconColor} />}
            {...props}
            sx={{ pt: 1, pb: 1, pl: 4, pr: 4, borderRadius: 8, ...sx }}
        >
            {label}
        </Button>
    );
};

export default DeleteButton;